const SCROLL_DOWN_CLASS = 'scroll-down';
const SCROLL_UP_CLASS = 'scroll-up';
const SCROLL_PAUSED_CLASS = 'scroll-paused';

let initialized = false;
let ticking = false;
let scrollingListenerActive = false;
let pauseTimeout;
let lastScrollTop = 0;

const setDirectionClass = (direction) => {
    const body = document.body;
    const root = document.documentElement;
    if (!body || !root) return;

    if (direction === 'down') {
        body.classList.add(SCROLL_DOWN_CLASS);
        body.classList.remove(SCROLL_UP_CLASS, SCROLL_PAUSED_CLASS);
    } else {
        body.classList.add(SCROLL_UP_CLASS);
        body.classList.remove(SCROLL_DOWN_CLASS, SCROLL_PAUSED_CLASS);
    }

    root.dataset.scrollDirection = direction;
};

const updateDirection = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    if (scrollTop === lastScrollTop) return;

    const direction = scrollTop > lastScrollTop ? 'down' : 'up';
    lastScrollTop = Math.max(scrollTop, 0);

    setDirectionClass(direction);
};

const onScroll = () => {
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(() => {
        updateDirection();
        ticking = false;
    });
};

const addScrollListener = () => {
    if (scrollingListenerActive) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    scrollingListenerActive = true;
};

const removeScrollListener = () => {
    if (!scrollingListenerActive) return;
    window.removeEventListener('scroll', onScroll);
    scrollingListenerActive = false;
};

const handleScrollStart = () => {
    clearTimeout(pauseTimeout);
    document.body?.classList.remove(SCROLL_PAUSED_CLASS);
    addScrollListener();
    updateDirection();
};

const handleScrollEnd = () => {
    removeScrollListener();
    pauseTimeout = window.setTimeout(() => {
        document.body?.classList.add(SCROLL_PAUSED_CLASS);
    }, 3000);
};

const init = () => {
    if (initialized) return;
    initialized = true;

    lastScrollTop = window.scrollY || document.documentElement.scrollTop || 0;

    window.addEventListener('scrollStart', handleScrollStart);
    window.addEventListener('scrollEnd', handleScrollEnd);

    updateDirection();
};

const destroy = () => {
    if (!initialized) return;
    initialized = false;

    window.removeEventListener('scrollStart', handleScrollStart);
    window.removeEventListener('scrollEnd', handleScrollEnd);
    removeScrollListener();
    clearTimeout(pauseTimeout);

    const body = document.body;
    const root = document.documentElement;
    if (body) {
        body.classList.remove(SCROLL_DOWN_CLASS, SCROLL_UP_CLASS, SCROLL_PAUSED_CLASS);
    }
    if (root) {
        delete root.dataset.scrollDirection;
    }
};

export default {
    init,
    destroy,
};
